import { h } from 'preact';
import { useHashLocation } from 'wouter-preact/use-hash-location';

import { IconAccount } from '../../../common/icons/icon-account';
import { IconCustomContent } from '../../../common/icons/icon-custom-content';
import { IconFilm } from '../../../common/icons/icon-film';
import { IconMerch } from '../../../common/icons/icon-merch';
import { IconMessage } from '../../../common/icons/icon-message';
import { IconMusic } from '../../../common/icons/icon-music';
import { IconPosts } from '../../../common/icons/icon-posts';
import { IconQRCode } from '../../../common/icons/icon-qr-code';
import { IconStar } from '../../../common/icons/icon-star';
import { IconTicket } from '../../../common/icons/icon-ticket';
import { IconVideoTab } from '../../../common/icons/icon-video-tab';
import { IconType } from '../../model/custom-content.interface';
import type { ContentTab } from '../../model/tab.interface';
import { ContentType } from '../../model/tab.interface';
import { useTranslation } from '../../../i18n';
import { PerksNavMobileLink } from './perks-nav-mobile-link.component';

interface Props {
  hasActiveFilters: boolean;
  onCloseNavOverflow: () => void;
  onTabClick: (tab: ContentTab) => void;
  tabs: ContentTab[];
}

const iconComponentMap: Partial<Record<IconType, any>> = {
  [IconType.TICKET]: IconTicket,
  [IconType.MESSAGE]: IconMessage,
  [IconType.MUSIC]: IconMusic,
  [IconType.FILM]: IconFilm,
  [IconType.STAR]: IconStar,
  [IconType.PAGE]: IconCustomContent,
};

const contentTypeIconMap: Record<ContentType, any> = {
  [ContentType.POST]: IconPosts,
  [ContentType.VIDEO]: IconVideoTab,
  [ContentType.ALBUM]: IconMusic,
  [ContentType.PRODUCT]: IconMerch,
  [ContentType.PROMOTION]: IconQRCode,
  [ContentType.CUSTOM]: IconCustomContent,
};

export const PerksNavMobileLinks = ({ hasActiveFilters, onCloseNavOverflow, onTabClick, tabs }: Props) => {
  const { t } = useTranslation();
  const [location] = useHashLocation();
  const isActive = (link: string) => location.includes(link);

  return (
    <>
      {tabs.map((tab) => {
        const link =
          tab.contentType === ContentType.CUSTOM
            ? `/pages/${tab.id}`
            : `/${tab.contentType.toLowerCase()}`
                .replace('post', 'posts')
                .replace('video', 'videos')
                .replace('album', 'music')
                .replace('product', 'merch')
                .replace('promotion', 'codes');

        const IconComponent =
          tab.contentType === ContentType.CUSTOM
            ? (iconComponentMap[tab.iconType!] ?? IconCustomContent)
            : contentTypeIconMap[tab.contentType];

        return (
          <PerksNavMobileLink
            key={tab.id ?? tab.contentType}
            show={true}
            link={link}
            isActive={isActive(link)}
            onClick={() => { onCloseNavOverflow(); onTabClick(tab); }}
            id={`single-mobile-${tab.contentType.toLowerCase()}-tab`}
            title={tab.name}
          >
            <IconComponent fill="#e8eaed" />
          </PerksNavMobileLink>
        );
      })}

      <PerksNavMobileLink
        link="/my-account"
        isActive={isActive('/my-account')}
        onClick={onCloseNavOverflow}
        id="single-mobile-my-account-tab"
        title={t('perks.account')}
      >
        <IconAccount fill="#e8eaed" />
      </PerksNavMobileLink>
    </>
  );
};
